/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Point_1_TextInputs */

const en_visa_eb5_point_1_text = /** @type {(inputs: Visa_Eb5_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successful cases typically depend on credible job-creation planning and clear records tracing the invested funds.`)
};

const pt_visa_eb5_point_1_text = /** @type {(inputs: Visa_Eb5_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos bem-sucedidos geralmente dependem de planejamento confiável de criação de empregos e registros claros que rastreiam os fundos investidos.`)
};

const es_visa_eb5_point_1_text = /** @type {(inputs: Visa_Eb5_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los casos exitosos generalmente dependen de una planificación creíble de creación de empleos y registros claros que rastreen los fondos invertidos.`)
};

/**
* | output |
* | --- |
* | "Successful cases typically depend on credible job-creation planning and clear records tracing the invested funds." |
*
* @param {Visa_Eb5_Point_1_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_point_1_text = /** @type {((inputs?: Visa_Eb5_Point_1_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Point_1_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_point_1_text(inputs)
	if (locale === "es") return es_visa_eb5_point_1_text(inputs)
	return en_visa_eb5_point_1_text(inputs)
});